var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon open",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.75C3.727 15.75.25 12.273.25 8S3.727.25 8 .25 15.75 3.727 15.75 8 12.273 15.75 8 15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 .5C3.864.5.5 3.864.5 8s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5S12.136.5 8 .5M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--theme-primary-200)",
    d: "m3.757 7 .707-.707L8 9.829l3.536-3.536.707.707L8 11.243z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronFooter);
export default __webpack_public_path__ + "static/media/chevron-footer.49c44114b7d4ef8343156b2a4031b1c2.svg";
export { ForwardRef as ReactComponent };